import { Box, Container, Typography, Button, Stack } from '@mui/material';
import { Phone as PhoneIcon } from '@mui/icons-material';

interface CallToActionProps {
  title?: string;
}

const CallToAction = ({ title = "We care about your comfort" }: CallToActionProps) => {
  return (
    <Box 
      sx={{ 
        bgcolor: '#f8fbff',
        py: 4,
        borderTop: '1px solid rgba(0, 102, 178, 0.08)',
        borderBottom: '1px solid rgba(0, 102, 178, 0.08)',
      }}
    >
      <Container maxWidth="lg">
        <Typography 
          variant="h4" 
          sx={{ 
            mb: 3,
            fontWeight: 600,
            color: '#0066b2',
            textAlign: 'center'
          }}
        >
          {title}
        </Typography>
        <Stack 
          direction={{ xs: 'column', sm: 'row' }} 
          spacing={2} 
          justifyContent="center"
        >
          <Button
            variant="contained"
            href="/enquiry"
            size="large"
            sx={{
              background: 'linear-gradient(135deg, #0066b2 0%, #3389d0 100%)',
              color: 'white',
              '&:hover': { 
                background: 'linear-gradient(135deg, #3389d0 0%, #4ca3e8 100%)',
                color: 'white',
              },
              px: 4,
              fontWeight: 600,
              transition: 'all 0.3s ease'
            }}
          >
            Enquire Online
          </Button>
          <Button
            variant="outlined"
            href="tel:0395879900"
            size="large"
            startIcon={<PhoneIcon />}
            sx={{
              color: '#0066b2',
              borderColor: '#0066b2',
              '&:hover': {
                background: 'transparent',
                borderColor: '#0066b2',
                color: '#0066b2'
              },
              px: 4
            }}
          >
            03 9587 9900
          </Button>
        </Stack>
      </Container>
    </Box>
  );
};

export default CallToAction; 